import Vue from 'vue'
import store from './store'

const rEvery = /^\*/
const rWeight = /^weight$/
const rFree = /^</

const invisibleRe = /[\0-\x1F\x7F-\x9F\xAD\u0378\u0379\u037F-\u0383\u038B\u038D\u03A2\u0528-\u0530\u0557\u0558\u0560\u0588\u058B-\u058E\u0590\u05C8-\u05CF\u05EB-\u05EF\u05F5-\u0605\u061C\u061D\u06DD\u070E\u070F\u074B\u074C\u07B2-\u07BF\u07FB-\u07FF\u082E\u082F\u083F\u085C\u085D\u085F-\u089F\u08A1\u08AD-\u08E3\u08FF\u0978\u0980\u0984\u098D\u098E\u0991\u0992\u09A9\u09B1\u09B3-\u09B5\u09BA\u09BB\u09C5\u09C6\u09C9\u09CA\u09CF-\u09D6\u09D8-\u09DB\u09DE\u09E4\u09E5\u09FC-\u0A00\u0A04\u0A0B-\u0A0E\u0A11\u0A12\u0A29\u0A31\u0A34\u0A37\u0A3A\u0A3B\u0A3D\u0A43-\u0A46\u0A49\u0A4A\u0A4E-\u0A50\u0A52-\u0A58\u0A5D\u0A5F-\u0A65\u0A76-\u0A80\u0A84\u0A8E\u0A92\u0AA9\u0AB1\u0AB4\u0ABA\u0ABB\u0AC6\u0ACA\u0ACE\u0ACF\u0AD1-\u0ADF\u0AE4\u0AE5\u0AF2-\u0B00\u0B04\u0B0D\u0B0E\u0B11\u0B12\u0B29\u0B31\u0B34\u0B3A\u0B3B\u0B45\u0B46\u0B49\u0B4A\u0B4E-\u0B55\u0B58-\u0B5B\u0B5E\u0B64\u0B65\u0B78-\u0B81\u0B84\u0B8B-\u0B8D\u0B91\u0B96-\u0B98\u0B9B\u0B9D\u0BA0-\u0BA2\u0BA5-\u0BA7\u0BAB-\u0BAD\u0BBA-\u0BBD\u0BC3-\u0BC5\u0BC9\u0BCE\u0BCF\u0BD1-\u0BD6\u0BD8-\u0BE5\u0BFB-\u0C00\u0C04\u0C0D\u0C11\u0C29\u0C34\u0C3A-\u0C3C\u0C45\u0C49\u0C4E-\u0C54\u0C57\u0C5A-\u0C5F\u0C64\u0C65\u0C70-\u0C77\u0C80\u0C81\u0C84\u0C8D\u0C91\u0CA9\u0CB4\u0CBA\u0CBB\u0CC5\u0CC9\u0CCE-\u0CD4\u0CD7-\u0CDD\u0CDF\u0CE4\u0CE5\u0CF0\u0CF3-\u0D01\u0D04\u0D0D\u0D11\u0D3B\u0D3C\u0D45\u0D49\u0D4F-\u0D56\u0D58-\u0D5F\u0D64\u0D65\u0D76-\u0D78\u0D80\u0D81\u0D84\u0D97-\u0D99\u0DB2\u0DBC\u0DBE\u0DBF\u0DC7-\u0DC9\u0DCB-\u0DCE\u0DD5\u0DD7\u0DE0-\u0DF1\u0DF5-\u0E00\u0E3B-\u0E3E\u0E5C-\u0E80\u0E83\u0E85\u0E86\u0E89\u0E8B\u0E8C\u0E8E-\u0E93\u0E98\u0EA0\u0EA4\u0EA6\u0EA8\u0EA9\u0EAC\u0EBA\u0EBE\u0EBF\u0EC5\u0EC7\u0ECE\u0ECF\u0EDA\u0EDB\u0EE0-\u0EFF\u0F48\u0F6D-\u0F70\u0F98\u0FBD\u0FCD\u0FDB-\u0FFF\u10C6\u10C8-\u10CC\u10CE\u10CF\u1249\u124E\u124F\u1257\u1259\u125E\u125F\u1289\u128E\u128F\u12B1\u12B6\u12B7\u12BF\u12C1\u12C6\u12C7\u12D7\u1311\u1316\u1317\u135B\u135C\u137D-\u137F\u139A-\u139F\u13F5-\u13FF\u169D-\u169F\u16F1-\u16FF\u170D\u1715-\u171F\u1737-\u173F\u1754-\u175F\u176D\u1771\u1774-\u177F\u17DE\u17DF\u17EA-\u17EF\u17FA-\u17FF\u180F\u181A-\u181F\u1878-\u187F\u18AB-\u18AF\u18F6-\u18FF\u191D-\u191F\u192C-\u192F\u193C-\u193F\u1941-\u1943\u196E\u196F\u1975-\u197F\u19AC-\u19AF\u19CA-\u19CF\u19DB-\u19DD\u1A1C\u1A1D\u1A5F\u1A7D\u1A7E\u1A8A-\u1A8F\u1A9A-\u1A9F\u1AAE-\u1AFF\u1B4C-\u1B4F\u1B7D-\u1B7F\u1BF4-\u1BFB\u1C38-\u1C3A\u1C4A-\u1C4C\u1C80-\u1CBF\u1CC8-\u1CCF\u1CF7-\u1CFF\u1DE7-\u1DFB\u1F16\u1F17\u1F1E\u1F1F\u1F46\u1F47\u1F4E\u1F4F\u1F58\u1F5A\u1F5C\u1F5E\u1F7E\u1F7F\u1FB5\u1FC5\u1FD4\u1FD5\u1FDC\u1FF0\u1FF1\u1FF5\u1FFF\u200B-\u200F\u202A-\u202E\u2060-\u206F\u2072\u2073\u208F\u209D-\u209F\u20BB-\u20CF\u20F1-\u20FF\u218A-\u218F\u23F4-\u23FF\u2427-\u243F\u244B-\u245F\u2700\u2B4D-\u2B4F\u2B5A-\u2BFF\u2C2F\u2C5F\u2CF4-\u2CF8\u2D26\u2D28-\u2D2C\u2D2E\u2D2F\u2D68-\u2D6E\u2D71-\u2D7E\u2D97-\u2D9F\u2DA7\u2DAF\u2DB7\u2DBF\u2DC7\u2DCF\u2DD7\u2DDF\u2E3C-\u2E7F\u2E9A\u2EF4-\u2EFF\u2FD6-\u2FEF\u2FFC-\u2FFF\u3040\u3097\u3098\u3100-\u3104\u312E-\u3130\u318F\u31BB-\u31BF\u31E4-\u31EF\u321F\u32FF\u4DB6-\u4DBF\u9FCD-\u9FFF\uA48D-\uA48F\uA4C7-\uA4CF\uA62C-\uA63F\uA698-\uA69E\uA6F8-\uA6FF\uA78F\uA794-\uA79F\uA7AB-\uA7F7\uA82C-\uA82F\uA83A-\uA83F\uA878-\uA87F\uA8C5-\uA8CD\uA8DA-\uA8DF\uA8FC-\uA8FF\uA954-\uA95E\uA97D-\uA97F\uA9CE\uA9DA-\uA9DD\uA9E0-\uA9FF\uAA37-\uAA3F\uAA4E\uAA4F\uAA5A\uAA5B\uAA7C-\uAA7F\uAAC3-\uAADA\uAAF7-\uAB00\uAB07\uAB08\uAB0F\uAB10\uAB17-\uAB1F\uAB27\uAB2F-\uABBF\uABEE\uABEF\uABFA-\uABFF\uD7A4-\uD7AF\uD7C7-\uD7CA\uD7FC-\uF8FF\uFA6E\uFA6F\uFADA-\uFAFF\uFB07-\uFB12\uFB18-\uFB1C\uFB37\uFB3D\uFB3F\uFB42\uFB45\uFBC2-\uFBD2\uFD40-\uFD4F\uFD90\uFD91\uFDC8-\uFDEF\uFDFE\uFDFF\uFE1A-\uFE1F\uFE27-\uFE2F\uFE53\uFE67\uFE6C-\uFE6F\uFE75\uFEFD-\uFF00\uFFBF-\uFFC1\uFFC8\uFFC9\uFFD0\uFFD1\uFFD8\uFFD9\uFFDD-\uFFDF\uFFE7\uFFEF-\uFFFB\uFFFE\uFFFF]/g

const scrollDuration = 300.0
const stepFn = (start, end) => {
  let s = start
  let e = end
  return function (current) {
    const a = (current - s) / (e - s)
    return ((a * a) / (1.6 * a)) || 0
  }
}

export const SHIPPING_GROUP_NAMES = {
  'flat-rate': 'ค่าขนส่งแบบคงที่ (Flat Rate)',
  'weight': 'ค่าขนส่งตามน้ำหนัก'
}

export const INVOICE_STATUSES = {
  WAIT_FOR_PAYMENT: 0,
  WAIT_FOR_APPROVE: 1,
  PAID: 2,
  CANCEL: 3
}

export const INVOICE_SUBSTATUSES = {
  NONE: 0,
  TIMEOUT: 1,
  PAYMENT_TIMEOUT: 2,
  ERROR: 3,
  PAYMENT_NOTIFIED: 4,
  PAYMENT_EXPIRED: 5,
  PAYMENT_PENDING: 6,
  ISSUE_PENDING: 7
}

const base64urldecode = (str) => {
  // Going backwards: from bytestream, to percent-encoding, to original string.
  return decodeURIComponent(window.atob(str).split('').map(c => {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
  }).join(''))
}

function _isVisible (elm) {
  if (elm.style && elm.style.display !== 'none') {
    let parent = elm.parentNode
    while (parent) {
      if (!_isVisible(parent)) {
        return false
      }
      parent = parent.parentNode
    }
    return true
  } else if (!elm.style) {
    return true
  }
  return false
}

function scrollToFirstErrors () {
  scrollToElement('[class$="--error"]')
}

function scrollToElement (selector) {
  const timeout = 5000
  let startTime = new Date()
  setTimeout(() => {
    const body = document.querySelector('body')
    const elements = document.querySelectorAll(selector)

    let currentMinY = 100000
    let elem = null
    for (let item of elements) {
      if (_isVisible(item)) {
        const bound = item.getBoundingClientRect()
        if (bound.top < currentMinY) {
          elem = item
          currentMinY = bound.top
        }
      }
    }
    if (!elem) {
      return
    }

    const elmPosition = elem.getBoundingClientRect()
    const startY = window.scrollY
    const targetY = (window.scrollY + elmPosition.top) - Math.max(90, 0.1 * window.innerHeight)
    const direction = targetY > startY ? 1 : -1
    const length = targetY - startY

    let endTs = 0
    let current

    const scrollFn = (ts) => {
      const now = new Date()
      if (now.getTime() - startTime.getTime() > timeout) {
        window.scroll(0, targetY)
        window.cancelAnimationFrame(handler)
        return
      }

      if (!endTs) {
        endTs = ts + scrollDuration
        current = stepFn(ts, endTs)
      }
      if ((direction === 1 && (window.scrollY > targetY || Math.ceil(window.innerHeight + window.scrollY) >= body.offsetHeight)) ||
        (direction === -1 && (window.scrollY < targetY || window.scrollY <= 0))
      ) {
        window.cancelAnimationFrame(handler)
      } else {
        let lengthToGo = length * current(ts)
        window.scroll(0, startY + lengthToGo)
        window.requestAnimationFrame(scrollFn)
      }
    }

    const handler = window.requestAnimationFrame(scrollFn)
  }, 100)
}

function processProductImages (product) {
  if (product.images && product.images.length > 0) {
    return (product.images || []).map((item, index) => {
      const url = decodeURIComponent(item)
      if (url.toLowerCase().match(/@2x\.(png|jpg|jpeg)/)) {
        const preview = url.replace(/@2x/, '')
        return {
          index: index,
          src: url,
          preview: preview,
          srcset: `${preview} 1x, ${item} 2x`
        }
      } else {
        return {
          index: index,
          src: url,
          preview: url
        }
      }
    })
  } else {
    const url = `${Vue.config.API_URL}/${Vue.config.DOMAIN}/products/${product.sku}/firstImage`
    return [{
      index: 0,
      src: url,
      preview: url
    }]
  }
}

function svg (svg) {
  return 'data:image/svg+xml;base64,' + window.atob(svg.replace(/.*base64,/, '')).replace(/.*base64,/, '').replace(/"$/, '')
}

function showCommonError (ok) {
  Vue.prototype.$modal.show({
    title: 'ผิดพลาด',
    text: 'มีบางอย่างผิดพลาด กรุณาลองใหม่อีกครั้ง',
    okButton: true,
    ok: ok
  })
}

function shippingFee (product, quantity, totalPrice) {
  if (!product.shippable || !product.shippingRules) {
    return 0
  }

  let total = 0
  const rules = product.shippingRules.split(',')
  for (let rule of rules) {
    const tokens = rule.split(' -> ')

    if (rEvery.test(tokens[0])) {
      const smallestUnit = parseInt(tokens[0].substr(1))
      const pricePerUnit = parseInt(tokens[1], 10)

      total += Math.ceil(quantity / smallestUnit) * pricePerUnit
    }

    if (rFree.test(tokens[0])) {
      const lessThan = parseInt(tokens[0].substr(1))
      const price = parseInt(tokens[1], 10)
      if (totalPrice < lessThan) {
        total += price
      }
    }

    if (rWeight.test(tokens[0])) {
      const weightSettingsTokens = tokens[1].split(';')
      const weightSettings = []
      for (let item of weightSettingsTokens) {
        const settings = item.split(':')
        weightSettings.push({
          weight: parseFloat(settings[0]),
          price: parseFloat(settings[1])
        })
      }

      const weight = product.attributes.weight * quantity
      let leafWeight = weight
      while (leafWeight > 0) {
        let desirePrice = 0
        for (let settings of weightSettings) {
          if (settings.weight >= leafWeight) {
            desirePrice = settings.price
            leafWeight -= settings.weight
            break
          }
        }

        if (!desirePrice) {
          const settings = weightSettings[weightSettings.length - 1]
          total += settings.price
          leafWeight -= settings.weight
        } else {
          total += desirePrice
        }
      }
    }
  }

  return total
}

function setBodyClasses (classes) {
  const body = document.getElementsByTagName('body')[0]
  body.setAttribute('class', classes)
}

function webTokenParse (input) {
  const parts = input.split('.')
  if (parts.length !== 3) {
    throw new Error('Must have three parts')
  }
  let token = {}
  token.header = parts[0]
  token.payload = JSON.parse(base64urldecode(parts[1]))
  token.crypto = parts[2]
  token.algorithm = JSON.parse(base64urldecode(parts[0]))
  return token
}

function processLoginResponse (resp) {
  const rawToken = resp.body.token
  const token = webTokenParse(rawToken)
  const payload = token.payload

  const opts = {
    autoLogout: false,
    headers: {
      Authorization: `Bearer ${rawToken}`
    }
  }

  return Vue.http.get(`members/${payload.id}`, opts)
    .then(response => {
      const body = response.body
      let user = body
      user.address = user.address || {}
      user.shippingContact = user.shippingContact || {}
      const shippingContact = body.shippingContact || {}

      store.dispatch('updateCheckoutInfo', Object.assign({
        firstName: shippingContact.firstName || user.firstName,
        lastName: shippingContact.lastName || user.lastName,
        address: ((user.address.address || '') + '\n' + (user.address.district || '')).trim(),
        province: user.address.province,
        postalCode: user.address.postcode,
        phone: shippingContact.telNo || user.telNo
      }, store.state.checkoutInfo))

      store.dispatch('setUser', user)
      store.dispatch('setToken', rawToken)
    })
}

function isEmptyAddress () {
  const info = store.state.checkoutInfo
  return !info || !info.firstName || !info.lastName || !info.address || !getProvinceCode(info.province) || !info.postalCode || !info.phone
}

function addToCart (product, attributes, quantity) {
  if (quantity && quantity > 0) {
    store.dispatch('addToCart', {
      product: product,
      attributes: attributes,
      quantity: quantity
    })

    fbTrack('ADDED_TO_CART', product.price * quantity, {
      CONTENT_TYPE: 'product',
      CONTENT_ID: getProductConfigSku(product, attributes),
      CURRENCY: 'THB'
    })
  } else {
    // TODO: show error
  }
}

function getInvoice (orderId, retrieve) {
  let url = `invoices/${orderId}`
  if (retrieve) {
    url += '?retrieve=true'
  }
  return Vue.http.get(url)
    .then(resp => {
      if (resp.status !== 200) {
        return Promise.reject(new Error(`Cannot get invoice status: ${resp.status} ${resp.statusText}`))
      }

      resp.body.status = resp.body.status ? resp.body.status : 0
      resp.body.substatus = resp.body.substatus ? resp.body.substatus : 0
      return Promise.resolve(resp.body)
    })
    .catch(err => {
      console.log(err)
      return Promise.reject(err)
    })
}

function getLastChar (value) {
  return value && value.charAt(value.length - 1)
}

function getEventKey (event) {
  let key = {
    8: 'Backspace',
    9: 'Tab',
    13: 'Enter',
    37: 'ArrowLeft',
    39: 'ArrowRight'
  }[event.keyCode]

  key = (event.keyCode === 0 || event.keyCode === 229) ? getLastChar(event.target.value) : event.key

  if (!key) {
    key = String.fromCharCode(event.keyCode)
  }

  return key
}

function parseDate (str) {
  const parsed = Date.parse(str)
  if (!isNaN(parsed)) {
    return parsed
  }

  return Date.parse(str.replace(/-/g, '/').replace(/[a-z]+/gi, ' '))
}

function range (start, end) {
  return Array(end - start + 1).fill().map((_, i) => i + start)
}

const banks = [
  { name_en: 'Bangkok Bank', name_th: 'ธนาคารกรุงเทพ', code: 'BBL' },
  { name_en: 'Kasikorn Bank', name_th: 'ธนาคารกสิกรไทย', code: 'KBANK' },
  { name_en: 'Krungthai Bank', name_th: 'ธนาคารกรุงไทย', code: 'KTB' },
  { name_en: 'Siam Commercial Bank', name_th: 'ธนาคารไทยพาณิชย์', code: 'SCB' },
  { name_en: 'Bank of Ayudhya', name_th: 'ธนาคารกรุงศรีอยุธยา', code: 'BAY' },
  { name_en: 'Kiatnakin Bank', name_th: 'ธนาคารเกียรตินาคิน', code: 'KKB' },
  { name_en: 'CIMB Thai', name_th: 'ธนาคารซีไอเอ็มบีไทย', code: 'CIMB' },
  { name_en: 'Tisco Bank', name_th: 'ธนาคารทิสโก้', code: 'TISCO' },
  { name_en: 'TTB Bank', name_th: 'ธนาคารทีเอ็มบีธนชาต', code: 'TTB' },
  { name_en: 'UOB Bank', name_th: 'ธนาคารยูโอบี', code: 'UOB' },
  { name_en: 'Standard Chartered Bank (Thai)', name_th: 'ธนาคารสแตนดาร์ดชาร์เตอร์ด (ไทย)', code: 'SCBT' },
  { name_en: 'Thai Credit Retail Bank', name_th: 'ธนาคารไทยเครดิตเพื่อรายย่อย', code: 'TCD' },
  { name_en: 'LH Bank', name_th: 'ธนาคารแลนด์ แอนด์ เฮาส์', code: 'LHBANK' },
  { name_en: 'ICBC Bank', name_th: 'ธนาคารไอซีบีซี (ไทย)', code: 'ICBC' },
  { name_en: 'SME Bank', name_th: 'ธนาคารพัฒนาวิสาหกิจขนาดกลางและขนาดย่อมแห่งประเทศไทย', code: 'SME' },
  { name_en: 'Bank for Agriculture and Agricultural Cooperatives', name_th: 'ธนาคารเพื่อการเกษตรและสหกรณ์การเกษตร (ธ.ก.ส.)', code: 'BAAC' },
  { name_en: 'EXIM Bank', name_th: 'ธนาคารเพื่อการส่งออกและนำเข้าแห่งประเทศไทย', code: 'EXIM' },
  { name_en: 'Government Savings Bank', name_th: 'ธนาคารออมสิน', code: 'GSB' },
  { name_en: 'Government Housing Bank', name_th: 'ธนาคารอาคารสงเคราะห์ (ธอส.)', code: 'GHB' },
  { name_en: 'Islamic Bank of Thailand', name_th: 'ธนาคารอิสลามแห่งประเทศไทย', code: 'ISALAM' },
  { name_en: 'Other', name_th: 'อื่นๆ', code: 'other' }
]

const provincesMap = {
  'TH-37': 'อำนาจเจริญ',
  'TH-15': 'อ่างทอง',
  'TH-14': 'พระนครศรีอยุธยา',
  'TH-10': 'กรุงเทพมหานคร',
  'TH-38': 'บึงกาฬ',
  'TH-31': 'บุรีรัมย์',
  'TH-24': 'ฉะเชิงเทรา',
  'TH-18': 'ชัยนาท',
  'TH-36': 'ชัยภูมิ',
  'TH-22': 'จันทบุรี',
  'TH-50': 'เชียงใหม่',
  'TH-57': 'เชียงราย',
  'TH-20': 'ชลบุรี',
  'TH-86': 'ชุมพร',
  'TH-46': 'กาฬสินธุ์',
  'TH-62': 'กำแพงเพชร',
  'TH-71': 'กาญจนบุรี',
  'TH-40': 'ขอนแก่น',
  'TH-81': 'กระบี่',
  'TH-52': 'ลำปาง',
  'TH-51': 'ลำพูน',
  'TH-42': 'เลย',
  'TH-16': 'ลพบุรี',
  'TH-58': 'แม่ฮ่องสอน',
  'TH-44': 'มหาสารคาม',
  'TH-49': 'มุกดาหาร',
  'TH-26': 'นครนายก',
  'TH-73': 'นครปฐม',
  'TH-48': 'นครพนม',
  'TH-30': 'นครราชสีมา',
  'TH-60': 'นครสวรรค์',
  'TH-80': 'นครศรีธรรมราช',
  'TH-55': 'น่าน',
  'TH-96': 'นราธิวาส',
  'TH-39': 'หนองบัวลำภู',
  'TH-43': 'หนองคาย',
  'TH-12': 'นนทบุรี',
  'TH-13': 'ปทุมธานี',
  'TH-94': 'ปัตตานี',
  'TH-82': 'พังงา',
  'TH-93': 'พัทลุง',
  'TH-56': 'พะเยา',
  'TH-67': 'เพชรบูรณ์',
  'TH-76': 'เพชรบุรี',
  'TH-66': 'พิจิตร',
  'TH-65': 'พิษณุโลก',
  'TH-54': 'แพร่',
  'TH-83': 'ภูเก็ต',
  'TH-25': 'ปราจีนบุรี',
  'TH-77': 'ประจวบคีรีขันธ์',
  'TH-85': 'ระนอง',
  'TH-70': 'ราชบุรี',
  'TH-21': 'ระยอง',
  'TH-45': 'ร้อยเอ็ด',
  'TH-27': 'สระแก้ว',
  'TH-47': 'สกลนคร',
  'TH-11': 'สมุทรปราการ',
  'TH-74': 'สมุทรสาคร',
  'TH-75': 'สมุทรสงคราม',
  'TH-19': 'สระบุรี',
  'TH-91': 'สตูล',
  'TH-17': 'สิงห์บุรี',
  'TH-33': 'ศรีสะเกษ',
  'TH-90': 'สงขลา',
  'TH-64': 'สุโขทัย',
  'TH-72': 'สุพรรณบุรี',
  'TH-84': 'สุราษฎร์ธานี',
  'TH-32': 'สุรินทร์',
  'TH-63': 'ตาก',
  'TH-92': 'ตรัง',
  'TH-23': 'ตราด',
  'TH-34': 'อุบลราชธานี',
  'TH-41': 'อุดรธานี',
  'TH-61': 'อุทัยธานี',
  'TH-53': 'อุตรดิตถ์',
  'TH-95': 'ยะลา',
  'TH-35': 'ยโสธร'
}

function getProvinces () {
  const r = /^[เแโไใ]/
  let provinces = []
  for (let i of Object.keys(provincesMap)) {
    provinces.push({ code: i, name: provincesMap[i] })
  }
  return provinces.sort((a, b) => {
    return a.name.replace(r, '') > b.name.replace(r, '') ? 1 : -1
  })
}

function getProvinceCode (provinceName) {
  for (let i of Object.keys(provincesMap)) {
    if (provinceName === provincesMap[i]) {
      return i
    }
  }
  return ''
}

function getBank (code) {
  return banks.filter(item => item.code === code)[0]
}

function isProductAvailable (product) {
  const now = (new Date()).getTime()
  return product.status === 1 &&
    (!product.notBefore || now >= product.notBefore) &&
    (!product.notAfter || now <= product.notAfter)
}

function timeBeforeProductAvailable (product) {
  const now = (new Date()).getTime()
  return product.notBefore - now
}

function ensure (object, prop) {
  return new Promise((resolve, reject) => {
    const t = setInterval(() => {
      if (object[prop]) {
        clearTimeout(t)
        resolve()
      }
    }, 100)
  })
}

function fbTrack (event, value, params) {
  ensure(window, 'fbApiInit').then(() => {
    window.FB.AppEvents.logEvent(event, value, params)
  })
}

function fbTrackPurchase (price, totalItems) {
  ensure(window, 'fbApiInit').then(() => {
    window.FB.AppEvents.logPurchase(price, 'thb', {
      CONTENT_TYPE: 'product',
      NUM_ITEMS: totalItems
    })
  })
}

function gaPageView (path) {
  ensure(window, 'ga').then(() => {
    window.ga('set', 'page', path)
    window.ga('send', 'pageview')
  })
}

function cleanEmailInvisibleChars (email) {
  return (email || '').replace(invisibleRe, '')
}

function getProductSubSku (product, choices) {
  if (!product.stockAttributes) {
    return ''
  }
  choices = choices || {}

  let subSkus = []
  for (let attr of product.stockAttributes) {
    subSkus.push(choices[attr.key] || '')
  }

  return subSkus.filter(item => item).join('_')
}

function getProductConfigSku (product, choices) {
  let sku = product.sku
  let subSku = getProductSubSku(product, choices)
  if (subSku) {
    return `${sku}:${subSku}`
  }

  return `${sku}`
}

function subSkuToAttributes (product, subSku) {
  if (!product.stockAttributes) {
    return {}
  }

  let attributes = {}
  let chunks = subSku.split('_')
  for (let i in chunks) {
    let attr = product.stockAttributes[i]
    attributes[attr.key] = chunks[i]
  }

  return attributes
}

function getCartShippingFee () {
  // Check cart is offline shipping
  if (store.state.offlineShipping && isCartOfflineShippable()) {
    return 0
  }

  const normalFee = store.state.cart.reduce((a, b) => {
    if (!b.product.shippable) {
      return a
    }
    if (b.product.shippingGroup) {
      return a
    }
    return a + shippingFee(b.product, b.quantity)
  }, 0)

  return normalFee + Object.keys(getCartShippingGroups()).reduce((a, b) => {
    return a + getShippingGroupFee(b)
  }, 0)
}

function getCartShippingGroups () {
  let groups = {}
  for (let item of store.state.cart) {
    if (item.product.shippable && item.product.shippingGroup) {
      const group = `${item.product.shippingGroup}_#_${item.product.shippingRules}`
      groups[group] = groups[group] || []
      groups[group].push(item)
    }
  }
  return groups
}

function getShippingGroupName (group) {
  return SHIPPING_GROUP_NAMES[group.replace(/:.*/, '')] || 'ค่าจัดส่ง'
}

function getShippingGroupFee (group) {
  const items = getCartShippingGroups()[group]
  if (!items || !items.length) {
    return 0
  }

  if (group.match(/weight:/)) {
    const sampleProduct = items[0].product
    const mockProduct = {
      shippable: true,
      shippingRules: sampleProduct.shippingRules,
      shippingGroup: group,
      attributes: {
        weight: 0
      }
    }
    mockProduct.attributes.weight = items.reduce((a, b) => {
      return a + (b.product.attributes.weight * b.quantity)
    }, 0)
    return shippingFee(mockProduct, 1, 0)
  }

  const sampleProduct = items[0].product
  const quantity = items.reduce((a, b) => {
    return a + b.quantity
  }, 0)
  const totalPrice = items.reduce((a, b) => {
    return a + b.quantity * b.product.calculatedPrice
  }, 0)
  return shippingFee(sampleProduct, quantity, totalPrice)
}

function getCartItemCount () {
  return store.state.cart.reduce((sum, item) => sum + item.quantity, 0)
}

function getCartTotalPrice () {
  return store.state.cart.reduce((sum, item) => {
    const amt = item.product.price * item.quantity
    if (item.product.shippable && item.attributes.info.shippingRequired && item.product.meta.donation_include_shipping_cost) {
      return sum + amt + (parseInt(item.product.meta.donation_include_shipping_cost, 10) || 0)
    }
    return sum + amt
  }, 0)
}

function getCartGrandTotalPrice () {
  return getCartTotalPrice() + getCartShippingFee()
}

function isCartEmpty () {
  return store.state.cart.length === 0
}

function isCartShippable () {
  let shippable = true

  for (let item of store.state.cart) {
    if (!item.product.shippable) {
      shippable = false
    }
  }
  return shippable
}

function isCartOfflineShippable () {
  return store.state.cart.reduce((a, b) => {
    return a && b.product.offlineShippable
  }, store.state.cart.length > 0)
}

function isOfflineShipping () {
  return store.state.offlineShipping && isCartOfflineShippable()
}

function setOfflineShipping (value) {
  store.dispatch('setOfflineShipping', value && isCartOfflineShippable())
}

function getOfflineShippingDetail (value) {
  const label = store.state.cart.map((a) => {
    if (a.product.offlineShippable && a.product.offlineShippableDetail) {
      // TODO: support multiple title
      return a.product.offlineShippableDetail
    }
  }).join('<br>')
  return label || ''
}

function getOfflineShippingNotice (value) {
  const label = store.state.cart.reduce((a, b) => {
    if (b.product.offlineShippable && b.product.offlineShippableNotice) {
      // TODO: support multiple title
      return b.product.offlineShippableNotice
    }
  }, '')
  return label || ''
}

function getOfflineShippingInfo (value) {
  const label = store.state.cart.reduce((a, b) => {
    if (b.product.offlineShippable && b.product.offlineShippableTitle) {
      // TODO: support multiple title
      return b.product.offlineShippableTitle
    }
  }, '')
  return label || 'รับ' + Vue.config.PRODUCT_TYPE + 'ด้วยตัวเอง ที่ ' + Vue.config.WEBSITE_NAME
}

function getOfflineShippingLabel (value) {
  return (isCartShippable() ? 'ต้องการ' : '') + getOfflineShippingInfo() + ' (ไม่เสียค่าจัดส่ง)'
}

function getShippingDetail (shippingType) {
  let hasOfflineShippable = false
  let groupMaps = {}
  let cartItems = store.state.cart

  if (!shippingType || shippingType === 'shipping') {
    cartItems.map((cart, key) => {
      const product = cart.product
      if (!product.shippable || !product.shippingRules) {
        return
      }

      hasOfflineShippable = hasOfflineShippable || product.offlineShippable

      let groupKey = product.shippingGroup + '::' + product.shippingRules + '::' + product.shippingGroupTitle
      groupMaps[groupKey] = groupMaps[groupKey] || {
        products: [],
        title: product.shippingGroupTitle,
        description: product.shippingRulesTitle
      }
      groupMaps[groupKey].products.push(product)
    })
  }

  if (!shippingType || shippingType === 'pickup') {
    if (isCartOfflineShippable()) {
      cartItems.map((cart, key) => {
        const product = cart.product
        if (!product.offlineShippable) {
          return
        }

        let groupKey = product.offlineShippableTitle + '::' + product.offlineShippableDetail + '::' + product.offlineShippableNotice
        groupMaps[groupKey] = groupMaps[groupKey] || {
          products: [],
          title: product.offlineShippableTitle,
          description: product.offlineShippableDetail,
          notice: product.offlineShippableNotice
        }
        groupMaps[groupKey].products.push(product)
      })
    }
  }

  return groupMaps
}

function getOfficialPages (productId) {
  const params = {
    data: JSON.stringify({
      official: true
    })
  }
  if (productId) {
    params.ref_obj_type = 'product'
    params.ref_obj_id = productId
  }

  return Vue.http.get('pages', { params: params })
    .then(resp => {
      const pages = []
      resp.body.pages.forEach(page => {
        try {
          page.data = JSON.parse(page.data)
        } catch (err) {
          console.log(err)
          page.data = {}
        }
        pages.push(page)
      })
      return pages
    })
    .catch(err => {
      this.$modal.show({
        title: this.$gettext('Error'),
        text: this.$gettext(`Cannot get pages. ${err.message}.`),
        okButtonText: this.$gettext('Try again'),
        ok: () => {
          window.location.reload()
        }
      })
    })
}

function getUserFullName (store) {
  const user = store.state.user
  if (user) {
    const fullNames = [user.firstName, user.lastName]
    return fullNames.join(' ').trim()
  }
}

function getWpPath (path) {
  return `${process.env.MAIN_WEBSITE_URL}/${path}`
}

/**
 * End date format must be DD/MM/YYYY
 *
 * @param endDate
 * @returns {number}
 */
function getRemainingDays (endDate) {
  let formattedEndDate = endDate.split('/').reverse().join('/')
  const today = new Date().setUTCHours(0, 0, 0, 0)
  const endDay = new Date(formattedEndDate).setUTCHours(0, 0, 0, 0)
  const diffSeconds = (endDay - today) / 1000
  return Math.floor(diffSeconds / (24 * 60 * 60))
}

export default {
  install (Vue, options) {
    Vue.prototype.$utils = {
      scrollToFirstErrors,
      scrollToElement,
      processProductImages,
      showCommonError,
      svg,
      shippingFee,
      setBodyClasses,
      webTokenParse,
      processLoginResponse,
      isEmptyAddress,
      addToCart,
      getInvoice,
      getEventKey,
      parseDate,
      range,
      banks,
      getBank,
      isProductAvailable,
      timeBeforeProductAvailable,
      fbTrack,
      fbTrackPurchase,
      provincesMap,
      getProvinces,
      getProvinceCode,
      gaPageView,
      cleanEmailInvisibleChars,
      getProductSubSku,
      getProductConfigSku,
      subSkuToAttributes,
      getCartShippingFee,
      getCartShippingGroups,
      getShippingGroupName,
      getShippingGroupFee,
      getCartItemCount,
      getCartTotalPrice,
      getCartGrandTotalPrice,
      isCartEmpty,
      isCartShippable,
      isCartOfflineShippable,
      isOfflineShipping,
      setOfflineShipping,
      getOfflineShippingInfo,
      getOfflineShippingLabel,
      getOfflineShippingDetail,
      getOfflineShippingNotice,
      getShippingDetail,
      ensure,
      getOfficialPages,
      getUserFullName,
      getWpPath,
      getRemainingDays
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils.js